import React from "react";
import { useSelector } from "react-redux";
import { Grid, Header, Segment, List } from "semantic-ui-react";
import { GamButtons } from "../utils/buttons";
import { AdServeData } from "../../banner/ad-data";

const Info = () => {
  const banner = useSelector((state) => state.banner);
  const user = useSelector((state) => state.user);
  return (
    <>
      <Grid padded className="brand-info">
        {user && banner.adServeData && (
          <Grid.Row>
            <Grid.Column computer={16} tablet={16} mobile={16}>
              <AdServeData data={banner.adServeData} />
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row>
          <Grid.Column computer={8} tablet={8} mobile={16}>
            <Header as="h3">Banner info</Header>
            <Segment>
              <List divided celled size="medium">
                <List.Item>
                  <List.Content>
                    <List.Header>Title</List.Header>
                    {banner.bannerTitle}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Ad number</List.Header>
                    {banner.adNumber}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Advertiser</List.Header>
                    {banner.advertiser}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Banner link</List.Header>
                    {banner.bannerURL}
                  </List.Content>
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {user && user.isAdOps && <GamButtons banner={banner} service="gam" />}
    </>
  );
};

export default Info;
